import { Validators } from "@angular/forms";

export interface CashOutField {
  name: string;
  label: string;
  validators: any[];
}

export const CASHOUT_COUNTRY_FIELDS: Record<string, CashOutField[]> = {
  CLP: [
    { name: 'customerPhone',   label: 'common.phoneNineDigits', validators: [] },
    { name: 'customerEmail',   label: 'common.email',           validators: [Validators.required, Validators.email] },
    { name: 'documentNumber',  label: 'common.documentNumber',  validators: [] },
    { name: 'documentType',    label: 'common.documentTypeCLP', validators: [] },
    { name: 'bankCode',        label: 'common.bankCodeEx',      validators: [] },
    { name: 'accountName',     label: 'common.accountName',     validators: [Validators.required] },
    { name: 'accountNo',       label: 'common.accountNo',       validators: [] },
    { name: 'accountType',     label: 'common.accountType',     validators: [] },
  ],

  COP: [
    { name: 'bankName',       label: 'common.bankName',         validators: [] },
    { name: 'accountNo',      label: 'common.accountNo',        validators: [] },
    { name: 'customerName',   label: 'common.fullName',         validators: [Validators.required] },
    { name: 'customerPhone',  label: 'common.phoneTenDigits',   validators: [] },
    { name: 'customerEmail',  label: 'common.email',            validators: [Validators.required, Validators.email] },
    { name: 'documentNumber', label: 'common.documentNumber',   validators: [] },
    { name: 'documentType',   label: 'common.documentTypeCOP',  validators: [] },
  ],

  MXN: [
    { name: 'bankCode',    label: 'common.bankCodeEx',  validators: [] },
    { name: 'accountNo',   label: 'common.accountNo',   validators: [] },
    { name: 'accountName', label: 'common.accountName', validators: [Validators.required] },
    { name: 'accountType', label: 'common.accountType', validators: [] },
  ],

  PEN: [
    { name: 'customerPhone',   label: 'common.phoneNineDigits',  validators: [] },
    { name: 'customerEmail',   label: 'common.email',            validators: [Validators.required, Validators.email] },
    { name: 'documentNumber',  label: 'common.documentNumber',   validators: [] },
    { name: 'documentType',    label: 'common.documentTypePEN',  validators: [] },
    { name: 'accountName',     label: 'common.accountName',      validators: [Validators.required] },
    { name: 'accountNo',       label: 'common.accountNo',        validators: [] },
    { name: 'accountType',     label: 'common.accountType',      validators: [] },
    { name: 'cciNo',           label: 'common.cciNo',            validators: [] },
    { name: 'bankCode',        label: 'common.bankCodeEx',       validators: [] },
  ],

  PHP: [
    { name: 'accountName', label: 'common.accountName', validators: [Validators.required] },
    { name: 'accountNo',   label: 'common.accountNo',   validators: [] },
    { name: 'bankCode',    label: 'common.bankCodeEx',  validators: [] },
  ],
};